<div (click)="onClick()" class="wrapper">
  <div [title]="T.settings.location_manager.navigate_to_your_location | translate" class="map-control-btn" [ngClass]="{ 'mobile-btn': isMobile, 'btn-label': showLabel }">
    <i class="material-symbols-outlined my-location-icon">my_location</i>
    <span *ngIf="showLabel">{{ T.settings.location_manager.navigate_to_your_location | translate }}</span>
  </div>
</div>
